/**
 * FaqSchema
 *
 * Renders a hidden <script type="application/ld+json"> block with FAQPage schema.
 * Drop this component anywhere on a page alongside a visible FAQ section.
 *
 * Props:
 *   faqs  — array of { question: string, answer: string }
 */
function FaqSchema({ faqs }) {
  if (!faqs || faqs.length === 0) return null;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(({ question, answer }) => ({
      '@type': 'Question',
      name: question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answer,
      },
    })),
  };

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema, null, 2) }}
    />
  );
}

export default FaqSchema;
